import React, { useEffect, useRef, useState } from 'react';
import logo from '../../assets/logo2.png';
import { Link, useSearchParams, useLocation } from 'react-router-dom';
import { HiOutlineUser, HiOutlineShoppingBag} from 'react-icons/hi';
import SearchBar from "./SearchBar";
import CartDrawer from '../Layout/CartDrawer';
import { HiBars3BottomRight } from 'react-icons/hi2';
import { IoMdClose } from 'react-icons/io';
import {ShoppingBag, User, Menu, X, ChevronDown, Search, Store}   from 'lucide-react';
import { useSelector, useDispatch  } from 'react-redux';
import { toggleCart } from '../../../redux/slices/cartSlice';


// Protected Logo Component
const ProtectedLogo = ({ logo, alt = "VESHH-EON Logo" }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const handleContextMenu = (e) => {
      if (e.target.tagName === 'IMG' || e.target.tagName === 'CANVAS') {
        e.preventDefault();
        return false;
      }
    };

    const handleKeyDown = (e) => {
      if (
        (e.ctrlKey && e.key === 's') ||
        (e.ctrlKey && e.key === 'u') ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i')) ||
        (e.ctrlKey && e.shiftKey && (e.key === 'J' || e.key === 'j')) ||
        (e.ctrlKey && e.shiftKey && (e.key === 'C' || e.key === 'c')) ||
        e.key === 'F12'
      ) {
        e.preventDefault();
        return false;
      }
    };

    const handleDragStart = (e) => {
      if (e.target.tagName === 'IMG' || e.target.tagName === 'CANVAS') {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('dragstart', handleDragStart);

    if (canvasRef.current && typeof logo === 'string') {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      const img = new Image();
      
      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        
        ctx.globalAlpha = 0.01;
        ctx.font = '12px Arial';
        ctx.fillStyle = '#000';
        ctx.fillText('© VESHH-EON', 10, 20);
        ctx.fillText(new Date().toISOString(), 10, 35);
      };
      
      img.crossOrigin = 'anonymous';
      img.src = logo;
    }

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('dragstart', handleDragStart);
    };
  }, [logo]);

  return (
    <div 
      className="relative inline-block h-[70px] select-none"
      style={{
        WebkitUserSelect: 'none',
        WebkitTouchCallout: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
        userSelect: 'none'
      }}
      onContextMenu={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
      onDrop={(e) => e.preventDefault()}
    >
      <canvas
        ref={canvasRef}
        className="h-[70px] w-auto pointer-events-none"
        style={{
          WebkitUserDrag: 'none',
          userDrag: 'none',
          WebkitUserSelect: 'none',
          MozUserSelect: 'none',
          msUserSelect: 'none',
          userSelect: 'none'
        }}
        onContextMenu={(e) => e.preventDefault()}
        onDragStart={(e) => e.preventDefault()}
      />

      <img 
        src={logo} 
        alt={alt}
        className="h-[70px] pointer-events-none select-none hidden"
        draggable="false"
        onContextMenu={(e) => e.preventDefault()}
        onDragStart={(e) => e.preventDefault()}
        style={{
          WebkitUserSelect: 'none',
          WebkitTouchCallout: 'none',
          MozUserSelect: 'none',
          msUserSelect: 'none',
          userSelect: 'none',
          WebkitUserDrag: 'none',
          userDrag: 'none'
        }}
      />

      <div 
        className="absolute inset-0 pointer-events-none opacity-0 hover:opacity-5 transition-opacity"
        style={{ 
          backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.03) 35px, rgba(255,255,255,.03) 70px)'
        }} 
      />

      <div 
        className="absolute inset-0 z-20 cursor-default"
        onContextMenu={(e) => e.preventDefault()}
        onDragStart={(e) => e.preventDefault()}
        onDrop={(e) => e.preventDefault()}
        onMouseDown={(e) => e.preventDefault()}
        onTouchStart={(e) => {
          if (e.touches.length > 1) {
            e.preventDefault();
          }
        }}
        style={{
          WebkitUserSelect: 'none',
          userSelect: 'none',
          WebkitTouchCallout: 'none'
        }}
      />
    </div>
  );
};

const Navbar = () => {
    const dispatch = useDispatch();
    const { isCartOpen } = useSelector((state) => state.cart);
    const [navDrawerOpen, setNavDrawerOpen] = useState(false);
    const [winterWearOpen, setWinterWearOpen] = useState(false);
    const [mobileWinterWearOpen, setMobileWinterWearOpen] = useState(false);
    const [activeIcon, setActiveIcon] = useState('');
    const location = useLocation();
    const {cart} = useSelector((state) => state.cart);
    const {user} = useSelector((state) => state.auth);

    const cartItemCount = cart?.products?.reduce((total, product) => total + product.quantity, 0) || 0;

    const toggleNavDrawer = () => {
        setNavDrawerOpen(!navDrawerOpen);
        setActiveIcon(prev => prev === 'menu' ? '' : 'menu');
    };

    const toggleCartDrawer = () => {
        dispatch(toggleCart());
        setActiveIcon(prev => prev === 'cart' ? '' : 'cart');
    };

  return (
  <>
    <style>{`
      .nav-link {
        position: relative;
        display: inline-block;
      }
      
      .nav-link::after {
        content: '';
        position: absolute;
        width: 0;
        height: 2px;
        bottom: -4px;
        left: 0;
        background-color: white;
        transition: width 0.3s ease;
      }
      
      .nav-link:hover::after {
        width: 100%;
      }
      
      .dropdown-menu {
        transition: all 0.3s ease;
      }
    `}</style>

    <nav className="bg-black">
      <div className="container mx-auto px-4 py-4">
        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center justify-center gap-8">
          {/* Left Links */}
          <div className="flex items-center gap-6">
            <Link to="/collections/all" className="nav-link text-white hover:text-white text-sm font-bold whitespace-nowrap transition-colors">
              NEW LAUNCHES
            </Link>
            <Link to="/collections/OverSized T-Shirt" className="nav-link text-white hover:text-white text-sm font-bold whitespace-nowrap transition-colors">
              OVERSIZED T-SHIRT
            </Link>
            <Link to="/collections/Tie Dye Oversized T-Shirt" className="nav-link text-white hover:text-white text-sm font-bold whitespace-nowrap transition-colors">
              TIE DYE
            </Link>
            <Link to="/brands" className="nav-link text-white hover:text-white text-sm font-bold whitespace-nowrap transition-colors">
              BRANDS
            </Link>
          </div>

          {/* Center Logo */}
          <div className="flex-shrink-0 mx-8">
            <Link to="/" className="flex items-center">
              <ProtectedLogo logo={logo} alt="VESHH-EON Logo" />
            </Link>
          </div>

          {/* Right Links */}
          <div className="flex items-center gap-6">
            <Link to="/collections/Essentials" className="nav-link text-white hover:text-white text-sm font-bold whitespace-nowrap transition-colors">
              ESSENTIALS
            </Link>
            
            {/* Winter Wear Dropdown */}
            <div 
              className="relative"
              onMouseEnter={() => setWinterWearOpen(true)}
              onMouseLeave={() => setWinterWearOpen(false)}
            >
              <button className="nav-link text-white hover:text-white flex items-center gap-1 text-sm font-bold whitespace-nowrap transition-colors">
                WINTER WEAR
                <ChevronDown className={`h-4 w-4 transition-transform duration-200 ${winterWearOpen ? 'rotate-180' : ''}`} />
              </button>
              
              {/* Dropdown Menu */}
              <div className={`dropdown-menu absolute left-0 top-full mt-2 w-56 bg-black border border-white/20 rounded-md overflow-hidden z-50 ${winterWearOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
                <div className="py-2">
                  <Link 
                    to="/collections/SweatShirt" 
                    onClick={() => setWinterWearOpen(false)}
                    className="block px-4 py-2 text-white hover:text-white hover:bg-white/10 transition-colors text-sm"
                  >
                    SWEATSHIRT
                  </Link>
                  <Link 
                    to="/collections/OverSized SweatShirt" 
                    onClick={() => setWinterWearOpen(false)}
                    className="block px-4 py-2 text-white hover:text-white hover:bg-white/10 transition-colors text-sm"
                  >
                    OVERSIZED SWEATSHIRT
                  </Link>
                  <Link 
                    to="/collections/Hoodie" 
                    onClick={() => setWinterWearOpen(false)}
                    className="block px-4 py-2 text-white hover:text-white hover:bg-white/10 transition-colors text-sm"
                  >
                    Hoodie
                  </Link>
                  <Link 
                    to="/collections/Zip Hoodie" 
                    onClick={() => setWinterWearOpen(false)}
                    className="block px-4 py-2 text-white hover:text-white hover:bg-white/10 transition-colors text-sm"
                  >
                    Zip Hoodie
                  </Link>
                  <Link 
                    to="/collections/OverSized Hoodie" 
                    onClick={() => setWinterWearOpen(false)}
                    className="block px-4 py-2 text-white hover:text-white hover:bg-white/10 transition-colors text-sm"
                  >
                    OverSized Hoodie
                  </Link>
                  <Link 
                    to="/collections/Acid Washed Hoodie" 
                    onClick={() => setWinterWearOpen(false)}
                    className="block px-4 py-2 text-white hover:text-white hover:bg-white/10 transition-colors text-sm"
                  >
                    Acid Washed Hoodie
                  </Link>
                  <Link 
                    to="/collections/Varsity Jacket" 
                    onClick={() => setWinterWearOpen(false)}
                    className="block px-4 py-2 text-white hover:text-white hover:bg-white/10 transition-colors text-sm"
                  >
                    Varsity Jacket
                  </Link>
                </div>
              </div>
            </div>
            
            <Link to="/contact" className="nav-link text-white hover:text-white text-sm font-bold whitespace-nowrap transition-colors">
              CONTACT
            </Link>
            <Link to="/about" className="nav-link text-white hover:text-white text-sm font-bold whitespace-nowrap transition-colors">
              ABOUT US
            </Link>
            
            {/* 🆕 Conditional Login/Vendor/Admin Links */}
            {!user ? (
              <Link to="/login" className="nav-link text-white hover:text-white text-sm font-bold whitespace-nowrap transition-colors">
                LOGIN
              </Link>
            ) : (
              <>
                {/* Show "Become a Vendor" for customers */}
                {user.role === "customer" && (
                  <Link 
                    to="/vendor/register" 
                    className="flex items-center gap-1 bg-gradient-to-r from-yellow-400 to-yellow-500 px-3 py-1.5 rounded text-sm text-black font-bold hover:from-yellow-500 hover:to-yellow-600 transition-all"
                  >
                    <Store size={16} />
                    Become Vendor
                  </Link>
                )}
                
                {/* Show Vendor Dashboard for vendors */}
                {user.role === "vendor" && (
                  <Link 
                    to="/vendor/dashboard" 
                    className="flex items-center gap-1 bg-gradient-to-r from-green-500 to-green-600 px-3 py-1.5 rounded text-sm text-white font-bold hover:from-green-600 hover:to-green-700 transition-all"
                  >
                    <Store size={16} />
                    Dashboard
                  </Link>
                )}
                
                {/* Show Admin Panel for admins */}
                {user.role === "admin" && (
                  <Link 
                    to="/admin" 
                    className="bg-white px-3 py-1.5 rounded text-sm text-black font-bold hover:bg-gray-200 transition-colors"
                  >
                    Admin Panel
                  </Link>
                )}
              </>
            )}
            
            <Link 
              to="/profile" 
              className="hover:opacity-80"
              onClick={() => setActiveIcon('profile')}
            >
              <User 
                size={22} 
                color="white" 
                strokeWidth={1.75}
                fill={location.pathname === '/profile' ? '#F5C400' : 'none'}
              />
            </Link>
            
            <button 
              onClick={toggleCartDrawer} 
              className="relative hover:opacity-80"
            >
              <ShoppingBag 
                color="white" 
                size={22}
                fill={activeIcon === 'cart' ? '#F5C400' : 'none'}
              />
              {cartItemCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-[#F5C400] text-black text-xs font-bold rounded-full px-1.5 py-0.5 min-w-[18px] text-center">
                  {cartItemCount}
                </span>
              )}
            </button>

            <SearchBar color="white" />
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className="md:hidden flex items-center justify-between">
          <button 
            onClick={toggleNavDrawer} 
            className="hover:opacity-80"
          >
            <Menu size={26} color="white" fill={activeIcon === 'menu' ? 'white' : 'none'} />
          </button>

          <Link to="/" className="flex items-center">
            <ProtectedLogo logo={logo} alt="VESHH-EON Logo" />
          </Link>

          <div className="flex items-center gap-4">
            {/* 🆕 Mobile Admin/Vendor Links */}
            {user?.role === "admin" && (
              <Link 
                to="/admin" 
                className="bg-white px-2 py-1 rounded text-xs text-black font-medium"
              >
                Admin
              </Link>
            )}
            
            {user?.role === "vendor" && (
              <Link 
                to="/vendor/dashboard" 
                className="bg-green-500 px-2 py-1 rounded text-xs text-white font-medium"
              >
                Vendor
              </Link>
            )}
            
            <Link 
              to="/profile" 
              className="hover:opacity-80"
              onClick={() => setActiveIcon('profile')}
            >
              <User 
                size={24} 
                color="white" 
                strokeWidth={1.75}
                fill={location.pathname === '/profile' ? 'white' : 'none'}
              />
            </Link>
            
            <button 
              onClick={toggleCartDrawer} 
              className="relative hover:opacity-80"
            >
              <ShoppingBag 
                color="white" 
                className="h-6 w-6"
                fill={activeIcon === 'cart' ? 'white' : 'none'}
              />
              {cartItemCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-[white] text-black text-xs font-bold rounded-full px-1.5 py-0.5 min-w-[18px] text-center">
                  {cartItemCount}
                </span>
              )}
            </button>

            <SearchBar color="white" />
          </div>
        </div>
      </div>
    </nav>
    
    
    <CartDrawer drawerOpen={isCartOpen} toggleCartDrawer={toggleCartDrawer} />

    {/* Mobile Drawer */}
    <div className={`fixed top-0 left-0 w-3/4 sm:w-1/2 md:w-1/3 h-full bg-black shadow-lg transform transition-transform duration-300 z-50 overflow-y-auto ${navDrawerOpen ? "translate-x-0" : "-translate-x-full"}`}>
      <div className="flex justify-end p-4">
        <button onClick={toggleNavDrawer}>
          <X color="white" />
        </button>
      </div>
      <div className="p-4">
        <nav className="space-y-4">
          {/* 🆕 Mobile Vendor/Admin Links at Top */}
          {user && (
            <div className="pb-4 mb-4 border-b border-white/20">
              {user.role === "customer" && (
                <Link 
                  to="/vendor/register" 
                  onClick={toggleNavDrawer}
                  className="flex items-center gap-2 bg-gradient-to-r from-yellow-400 to-yellow-500 px-4 py-2 rounded text-black font-bold hover:from-yellow-500 hover:to-yellow-600 transition-all"
                >
                  <Store size={18} />
                  Become a Vendor
                </Link>
              )}
              
              {user.role === "vendor" && (
                <Link 
                  to="/vendor/dashboard" 
                  onClick={toggleNavDrawer}
                  className="flex items-center gap-2 bg-gradient-to-r from-green-500 to-green-600 px-4 py-2 rounded text-white font-bold hover:from-green-600 hover:to-green-700 transition-all"
                >
                  <Store size={18} />
                  Vendor Dashboard
                </Link>
              )}
              
              {user.role === "admin" && (
                <Link 
                  to="/admin" 
                  onClick={toggleNavDrawer}
                  className="flex items-center gap-2 bg-white px-4 py-2 rounded text-black font-bold hover:bg-gray-200 transition-all"
                >
                  Admin Panel
                </Link>
              )}
            </div>
          )}
          
          <Link to="/collections/all" onClick={toggleNavDrawer} className="block text-white hover:text-white transition-colors">
            New Launches
          </Link>
          <Link to="/collections/OverSized T-Shirt" onClick={toggleNavDrawer} className="block text-white hover:text-white transition-colors">
            OverSized T-Shirt
          </Link>
          <Link to="/collections/Tie Dye Oversized T-Shirt" onClick={toggleNavDrawer} className="block text-white hover:text-white transition-colors">
            Tie Dye Oversized T-Shirt
          </Link>
          <Link to="/brands" onClick={toggleNavDrawer} className="block text-white hover:text-white transition-colors">
            Brands
          </Link>
          <Link to="/collections/Essentials" onClick={toggleNavDrawer} className="block text-white hover:text-white transition-colors">
            Essentials
          </Link>
          
          {/* Mobile Winter Wear Dropdown */}
          <div>
            <button 
              onClick={() => setMobileWinterWearOpen(!mobileWinterWearOpen)}
              className="w-full flex items-center justify-between text-white hover:text-white transition-colors"
            >
              <span>Winter Wear</span>
              <ChevronDown className={`h-4 w-4 transition-transform duration-200 ${mobileWinterWearOpen ? 'rotate-180' : ''}`} />
            </button>
            {mobileWinterWearOpen && (
              <div className="ml-4 mt-2 space-y-2">
                <Link to="/collections/SweatShirt" onClick={toggleNavDrawer} className="block text-white/80 hover:text-white transition-colors text-sm">
                  SweatShirt
                </Link>
                <Link to="/collections/OverSized SweatShirt" onClick={toggleNavDrawer} className="block text-white/80 hover:text-white transition-colors text-sm">
                  OverSized SweatShirt
                </Link>
                <Link to="/collections/Hoodie" onClick={toggleNavDrawer} className="block text-white/80 hover:text-white transition-colors text-sm">
                  Hoodie
                </Link>
                <Link to="/collections/Zip Hoodie" onClick={toggleNavDrawer} className="block text-white/80 hover:text-white transition-colors text-sm">
                  Zip Hoodie
                </Link>
                <Link to="/collections/OverSized Hoodie" onClick={toggleNavDrawer} className="block text-white/80 hover:text-white transition-colors text-sm">
                  OverSized Hoodie
                </Link>
                <Link to="/collections/Acid Washed Hoodie" onClick={toggleNavDrawer} className="block text-white/80 hover:text-white transition-colors text-sm">
                  Acid Washed Hoodie
                </Link>
                <Link to="/collections/Varsity Jacket" onClick={toggleNavDrawer} className="block text-white/80 hover:text-white transition-colors text-sm">
                  Varsity Jacket
                </Link>
              </div>
            )}
          </div>
          
          <Link to="/contact" onClick={toggleNavDrawer} className="block text-white hover:text-white transition-colors">
            Contact
          </Link>
          <Link to="/about" onClick={toggleNavDrawer} className="block text-white hover:text-white transition-colors">
            About Us
          </Link>
          
          {/* 🆕 Show Login only if not logged in */}
          {!user && (
            <Link to="/login" onClick={toggleNavDrawer} className="block text-white hover:text-white transition-colors">
              Login
            </Link>
          )}
        </nav>
      </div>
    </div>
  </>
);
};

export default Navbar;
